import { z } from 'zod';
/**
 * The four RocketPhone deployment environments. Every run is pinned to exactly
 * one of these; it determines gateway hosts, Remote Site Settings, Trusted URLs
 * and the Admin Portal environment code.
 */
export const environmentIdSchema = z.enum(['dev', 'qa', 'staging', 'production']);
export const ENVIRONMENT_IDS = environmentIdSchema.options;
/** HTTP verbs used anywhere in the RocketPhone API surface. */
export const httpMethodSchema = z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD']);
/**
 * Outcome vocabulary shared by assertions, steps and runs so the UI can use one
 * badge component and one colour scale throughout.
 */
export const outcomeSchema = z.enum([
    'pending',
    'running',
    'passed',
    'warning',
    'failed',
    'skipped',
    'blocked',
]);
/** Outcomes that mean the work is over, whatever the verdict. */
export const TERMINAL_OUTCOMES = [
    'passed',
    'warning',
    'failed',
    'skipped',
    'blocked',
];
export function isTerminalOutcome(outcome) {
    return TERMINAL_OUTCOMES.includes(outcome);
}
/**
 * Rolls a set of child outcomes into a single parent outcome. Failure dominates,
 * then blocked, then still-running, then warning. A parent with no children at
 * all is treated as skipped rather than silently passing.
 */
export function rollUpOutcome(children) {
    if (children.length === 0)
        return 'skipped';
    if (children.includes('failed'))
        return 'failed';
    if (children.includes('blocked'))
        return 'blocked';
    if (children.includes('running') || children.includes('pending'))
        return 'running';
    if (children.includes('warning'))
        return 'warning';
    if (children.every((outcome) => outcome === 'skipped'))
        return 'skipped';
    return 'passed';
}
export const isoTimestampSchema = z.string().datetime({ offset: true });
export function ok(value) {
    return { ok: true, value };
}
export function err(error) {
    return { ok: false, error };
}
//# sourceMappingURL=common.js.map